import { DataGrid } from '@mui/x-data-grid';
import { Box, Grid, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import CheckActive from 'assets/icons/checkbox_active.svg';
import CheckInactive from 'assets/icons/checkbox_inactive.svg';
import { usePosCoupons } from 'pages/PosSettings/hooks/usePosCoupons';

const PopularItemCoupon = () => {
  const { t } = useTranslation();
  const { marketingCoupons, loading } = usePosCoupons();

  const genericColumns = [
    {
      field: 'promotionName',
      headerName: t('Promotion'),
      flex: 1,
      sortable: false,
      filterable: false,
      editable: false,
    },
    {
      field: 'couponCode',
      headerName: t('website_settings.coupon_code'),
      flex: 1,
      sortable: false,
      filterable: false,
      editable: false,
    },
    {
      field: 'discountLabel',
      headerName: t('website_settings.amount_percent'),
      flex: 1,
      sortable: false,
      editable: false,
      filterable: false,
      renderCell: ({ value }) => (
        <Typography sx={{ textAlign: 'right', width: '100%' }}>{value}</Typography>
      ),
    },
    {
      field: 'startAt',
      headerName: t('website_settings.start_date_'),
      editable: false,
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: ({ value }) => (value ? moment(value).format('MM/DD/YYYY') : '—'),
    },
    {
      field: 'endAt',
      headerName: t('website_settings.end_date_'),
      editable: false,
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: ({ value }) => (value ? moment(value).format('MM/DD/YYYY') : '—'),
    },
    {
      field: 'freeDelivery',
      headerName: t('website_settings.free_delivery'),
      editable: false,
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: ({ row }) => {
        return <img src={row.freeDelivery ? CheckActive : CheckInactive} alt="ONLINE_ICON" />;
      },
    },
  ];

  return (
    <Grid container spacing={2} sx={{ mt: 4 }}>
      <Grid item xs={12}>
        <Stack sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography sx={{ mt: 2 }} variant="h6">
            {t('website_settings.coupons_or_marketing')}
          </Typography>
        </Stack>
        <Box
          sx={{
            my: 2,
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: (theme) => theme.palette.primary.main,
              color: 'white',
            },
            '& .MuiDataGrid-row	': {
              '&:nth-of-type(odd)': {
                backgroundColor: (theme) => theme.palette.action.hover,
              },
            },
            '& .MuiDataGrid-sortIcon': {
              color: 'white',
            },
            '& .MuiDataGrid-filterIcon': {
              color: 'white',
            },
            '& .MuiDataGrid-menuIcon	': {
              '& .MuiButtonBase-root': { color: 'white' },
            },
          }}
        >
          <DataGrid
            autoHeight={true}
            hideFooterPagination={true}
            hideFooterSelectedRowCount={true}
            isEditable={false}
            rows={marketingCoupons}
            columns={genericColumns}
            loading={loading}
          />
        </Box>
      </Grid>
    </Grid>
  );
};
export default PopularItemCoupon;
